export const TEXT_VARIANTS = {
    "body-xs": { fontSize: "1.1rem", lineHeight: "1.4", fontWeight: "400" },
    "body-sm": { fontSize: "1.2rem", lineHeight: "1.4", fontWeight: "400" },
    "body-md": { fontSize: "1.3rem", lineHeight: "1.4", fontWeight: "400" },
    "body-lg": { fontSize: "1.4rem", lineHeight: "1.4", fontWeight: "400" },
    "body-xl": { fontSize: "1.5rem", lineHeight: "1.4", fontWeight: "400" },
    "body-2xl": { fontSize: "1.8rem", lineHeight: "1.4", fontWeight: "400" },
    "sentence-xs": {
        fontSize: "1.1rem",
        lineHeight: "1.5",
        fontWeight: "400",
        letterSpacing: "-0.03em",
        wordBreak: "keep-all",
    },
    "sentence-sm": {
        fontSize: "1.2rem",
        lineHeight: "1.5",
        fontWeight: "400",
        letterSpacing: "-0.03em",
        wordBreak: "keep-all",
    },
    "sentence-md": {
        fontSize: "1.3rem",
        lineHeight: "1.5",
        fontWeight: "400",
        letterSpacing: "-0.03em",
        wordBreak: "keep-all",
    },
    "sentence-lg": {
        fontSize: "1.4rem",
        lineHeight: "1.5",
        fontWeight: "400",
        letterSpacing: "-0.03em",
        wordBreak: "keep-all",
    },
    "sentence-xl": {
        fontSize: "1.6rem",
        lineHeight: "1.5",
        fontWeight: "400",
        letterSpacing: "-0.03em",
        wordBreak: "keep-all",
    },
    "title-xs": { fontSize: "1.2rem", lineHeight: "1.4", fontWeight: "500" },
    "title-sm": { fontSize: "1.3rem", lineHeight: "1.4", fontWeight: "500" },
    "title-md": { fontSize: "1.4rem", lineHeight: "1.4", fontWeight: "500" },
    "title-lg": { fontSize: "1.6rem", lineHeight: "1.4", fontWeight: "500" },
    "title-xl": { fontSize: "2rem", lineHeight: "1.4", fontWeight: "500" },
    "title-2xl": { fontSize: "2.4rem", lineHeight: "1.4", fontWeight: "500" },
    "styled-sm": { fontSize: "1.2rem", lineHeight: "1.4", fontWeight: "400" },
    "styled-md": { fontSize: "1.4rem", lineHeight: "1.4", fontWeight: "400" },
    "styled-lg": { fontSize: "1.6rem", lineHeight: "1.4", fontWeight: "400" },
};
